import React, { lazy, Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Loader from './components/Loader';
import Footer from './components/Footer';
import { LanguageProvider } from './context/LanguageContext';
import './App.css';

// Lazy load the pages
const Home = lazy(() => import('./pages/Home'));
const OverOns = lazy(() => import('./pages/OverOns'));
const Menu = lazy(() => import('./pages/Menu'));
const EventsMenu = lazy(() => import('./pages/EventsMenu'));
const Reserveren = lazy(() => import('./pages/Reserveren'));
const EventReservation = lazy(() => import('./pages/EventReservation'));
const EventPaymentSuccess = lazy(() => import('./pages/EventPaymentSuccess'));
const EventPaymentCancel = lazy(() => import('./pages/EventPaymentCancel'));
const Contact = lazy(() => import('./pages/Contact'));

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

// This component wraps the Routes and handles showing the loader on every navigation.
function AppContent() {
  const location = useLocation();
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    // When the location changes, show the loader.
    setIsNavigating(true);

    // Simulate a delay (adjust duration as needed).
    const timer = setTimeout(() => {
      setIsNavigating(false);
    }, 500); // Loader will be visible for at least 500ms

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      <ScrollToTopOnRouteChange />
      {/* Show our custom loader overlay on every route change */}
      {isNavigating && <Loader />}
      <Suspense fallback={<Loader />}>
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/overons" element={<OverOns />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/eventsmenu" element={<EventsMenu />} />
          <Route path="/reserveren" element={<Reserveren />} />
          <Route path="/event-reserveren" element={<EventReservation />} />
          <Route path="/event-payment-success" element={<EventPaymentSuccess />} />
          <Route path="/event-payment-cancel" element={<EventPaymentCancel />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Suspense>
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="app">
          <Header />
          <AppContent />
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
